import { CheckmarkFilled, CloseFilled } from '@carbon/react/icons';
import classNames from 'classnames';
import type { AfeVerificationState } from './types';
import styles from './afe-verification-indicator.module.scss';

interface AfeVerificationIndicatorProps {
  state: AfeVerificationState | null | undefined;
  className?: string;
}

const AfeVerificationIndicator = ({
  state,
  className,
}: AfeVerificationIndicatorProps) => {
  if (state === 'verified') {
    return (
      <span className={classNames(styles.indicator, className)}>
        <CheckmarkFilled className={styles.verified} />
        <span>Correct</span>
      </span>
    );
  }

  if (state === 'non_verified') {
    return (
      <span className={classNames(styles.indicator, className)}>
        <CloseFilled className={styles.nonVerified} />
        <span>Incorrect</span>
      </span>
    );
  }

  // 'unreviewed', null, undefined, or any unrecognized value → dash.
  return (
    <span className={classNames(styles.indicator, className)}>
      <span className={styles.dash}>--</span>
    </span>
  );
};

export { AfeVerificationIndicator };
